import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, ChevronRight } from "lucide-react";
import { api } from "../api";
import { SectionTitle } from "../components";
import { useSeo } from "../seo";

const Fade = ({ children, delay = 0 }) => (
  <div className="xp-fade-in" style={{ animationDelay: `${delay}s` }}>{children}</div>
);

export default function BrandsPage() {
  const [brands, setBrands] = useState(null);
  useSeo({
    title: "The Urban Family — Urban Turban & Urban Express",
    description: "Urban by VeerGi is one family of Punjabi kitchens: Urban Turban (the flagship restaurant) and Urban Express are open now — one passport across all of them.",
    path: "/experience/brands",
  });
  useEffect(() => {
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => setBrands([]));
  }, []);
  return (
    <div data-testid="brands-page" className="px-4 pt-6 pb-10 mx-auto w-full max-w-5xl">
      <SectionTitle kicker="One passport · every Urban kitchen" title="The Urban family" testId="brands-title" />
      <p className="text-sm text-white/50 -mt-3 mb-5">Your points, stamps and phone work across every brand.</p>
      {!brands && <p className="text-xs text-white/40">Loading…</p>}
      <div className="space-y-3">
        {(brands || []).map((b, i) => (
          <Fade key={b.key} delay={i * 0.05}>
            <Link
              to={`/experience/brands/${b.key}`}
              data-testid={`brand-card-${b.key}`}
              className="block rounded-2xl bg-[#121212] border p-4 transition-colors hover:border-[#D4AF37]/50"
              style={{ borderColor: `${b.accent}44` }}
            >
              <div className="flex items-center gap-3">
                <span
                  className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
                  style={{ background: `${b.accent}1a`, color: b.accent, border: `1px solid ${b.accent}55`  }} data-brand-ink="1"
                >
                  <Store size={18} />
                </span>
                <div className="flex-1 min-w-0">
                  <p className="font-display text-xl font-bold leading-tight">{b.name}</p>
                  <p className="text-[11px] text-white/50">{b.tagline}</p>
                </div>
                <ChevronRight size={16} className="text-white/30 shrink-0" />
              </div>
              <div className="flex items-center gap-2 mt-3 flex-wrap">
                <span className="text-[9px] font-black tracking-widest rounded-full px-2.5 py-1"
                  style={{ background: `${b.accent}22`, color: b.accent  }} data-brand-ink="1">
                  {b.item_count} ITEMS
                </span>
                {b.coming_soon ? (
                  <span data-testid={`brand-coming-soon-${b.key}`} className="text-[9px] font-black tracking-widest rounded-full px-2.5 py-1"
                    style={{ background: `${b.accent}22`, color: b.accent  }} data-brand-ink="1">
                    COMING SOON
                  </span>
                ) : b.orderable ? (
                  <span className="text-[9px] font-black tracking-widest rounded-full px-2.5 py-1 bg-[#D4AF37]/15 text-[#D4AF37]">
                    PICKUP · PAY AT COUNTER
                  </span>
                ) : (
                  <span data-testid={`brand-browse-only-${b.key}`} className="text-[9px] font-black tracking-widest rounded-full px-2.5 py-1 bg-white/10 text-white/60">
                    BROWSE ONLY
                  </span>
                )}
              </div>
            </Link>
          </Fade>
        ))}
      </div>
    </div>
  );
}
